import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { Splash } from './Splash'

/** Wpuszcza tylko zalogowanych; zapamiętuje adres docelowy na czas logowania. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'loading') return <Splash label="Sprawdzanie sesji…" />
  if (status === 'anonymous') {
    return <Navigate to="/logowanie" replace state={{ from: location.pathname + location.search }} />
  }
  return <>{children}</>
}
